import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Colors } from "theme/colors";

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledLocaleSwitcher = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
  margin-top: 5rem;
`;

interface LocaleProps {
  $active: boolean;
}

export const StyledLocale = styled.div<LocaleProps>`
  color: ${Colors.BLACK};
  cursor: pointer;

  ${(props) =>
    props.$active &&
    css`
      text-decoration: underline;
      pointer: default;
      pointer-events: none;
    `}
`;

export const StyledPrivacyPolicy = styled.div`
  cursor: pointer;
`;

export const StyledAccessibility = styled.div`
  cursor: pointer;
`;

export const StyledLinks = styled.div`
  color: ${Colors.BLACK};
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1.75rem;
`;
